module.exports = __webpack_public_path__ + "img/imagotype-WeChamber.d052d718.jpg";